import oidcAuthConfig from '../oidcAuthConfig';
const getCommonLabels = () => (sessionStorage.getItem('lng') === 'fr'
  ? require('./../labels/labels.french.json')
  : require('./../labels/labels.json')).commonLabels;
export function getDateStr(timestamp = null) {
  if (!timestamp) return '--';
  const commonLabels = getCommonLabels();
  const date = new Date(timestamp);
  const dayOfTheWeek = commonLabels.dates.weekdays[date.getDay()];
  const month = commonLabels.dates.months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = `0${date.getHours()}`.substr(-2);
  const minutes = `0${date.getMinutes()}`.substr(-2);
  const tzAbbr = date.toString().split('(')[1].trim().match(/\b\w/g).join('');
  return `${dayOfTheWeek} ${day}, ${month} ${year}, ${hours}:${minutes} (${tzAbbr})`;
}

export function getShortDateTimeStr(timestamp = null) {
  if (!timestamp) return '--';
  const commonLabels = getCommonLabels();
  const date = new Date(timestamp);
  const month = commonLabels.dates.months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = `0${date.getHours()}`.substr(-2);
  const minutes = `0${date.getMinutes()}`.substr(-2);
  const tzAbbr = date.toString().split('(')[1].trim().match(/\b\w/g).join('');
  return `${month} ${day}, ${year}, ${hours}:${minutes} (${tzAbbr})`;
}

export function getShortDateWithoutTimeStr(timestamp = null) {
  if (!timestamp) return '--';
  const date = new Date(timestamp);
  const month = ('0' + (date.getMonth()+1)).slice(-2) ;
  const day = ('0' + (date.getDate())).slice(-2);
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

export function getUtcString(timestamp) {
  return new Date(timestamp).toISOString();
}

export function getUtcStringWithoutHours(timestamp) {
  const utcString = getUtcString(timestamp).split('T');
  return `${utcString[0]}T00:00:00.000Z`;
}

export function getDateVerbiage(timestamp) {
  if (!timestamp) return;
  const date = new Date(timestamp);
  if (date.getDate() === 1 || date.getDate() === 21 || date.getDate() === 31)
    return 'st';
  else if (date.getDate() === 2 || date.getDate() === 22) return 'nd';
  else if (date.getDate() === 3 || date.getDate() === 23) return 'rd';
  else return 'th';
}

export function createDateFromDateString(dateString) {
  // from dateString in AAAA-MM-DD format

  if(!dateString) return;

  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day); // Months in JavaScript are 0-indexed, so we subtract 1 from the month
  date.setHours(12, 0, 0, 0); // Set the time to noon (12:00 PM) in the local time zone
  return date;
}

// rever the first name and the name in a string
export function reverseName(name) {
  if(!name) return;
  // Split the string by spaces into an array
  const nameParts = name.split(' ');

  // Reverse the array (this swaps first and last names)
  const reversedName = nameParts.reverse();

  // Join the reversed array back into a string
  return reversedName.join(' ');
}

export function isAscending(array) {
  return array?.every((value, index) => index === 0 || array[index - 1] <= value);
}

export function detectDevice() {
  const userAgent = navigator.userAgent;
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  if (/iPad|Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(userAgent) ||
      (isTouchDevice && window.matchMedia("(max-width: 1024px)").matches)) {
    return "tablet";
  } else if (!isTouchDevice) {
    return "desktop";
  } else {
    return "unknown";
  }
}

export function fetchVersionAsync() {
  return fetch('assets/version.json')
    .then((res) => res.json())
    .then((data) => data.version)
    .catch(() => '');
}

/**
 * Check if the current logged-in user is an admin
 * @param {string} staffId - Optional staffId to check, defaults to session storage
 * @returns {boolean} - True if user is admin, false otherwise
 */
export function isAdmin(staffId = null) {
  const userStaffId = staffId || sessionStorage.getItem('staffId');
  const isAdminField = sessionStorage.getItem(oidcAuthConfig.isAdminFieldName);

  return userStaffId === getCommonLabels().ADMIN ||
    isAdminField === oidcAuthConfig.isAdminFieldValue;
}

/**
 * Builds a URL with isAdminImpersonation parameter if admin is impersonating
 * @param {string} baseUrl - The API endpoint URL
 * @returns {string} - URL with isAdminImpersonation parameter if applicable
 */
export function buildUrlWithAdminImpersonation(baseUrl) {
  const isImpersonating = sessionStorage.getItem('admin') === getCommonLabels().ADMIN;
  if (!isImpersonating) return baseUrl;
  
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}isAdminImpersonation=true`;
}

/**
 * Returns the appropriate bid sessions endpoint URL based on admin impersonation status
 * When admin is impersonating, use latest-bid-sessions (which includes closed sessions)
 * Otherwise use bid-sessions endpoint
 * @returns {string} - The bid sessions endpoint URL
 */
export function getBidSessionsUrl() {
  const isImpersonating = sessionStorage.getItem('admin') === getCommonLabels().ADMIN;
  if (isImpersonating) {
    return 'preferences/latest-bid-sessions/?isAdminImpersonation=true';
  }
  return 'preferences/bid-sessions/';
}
